import { Typography } from "antd";
import WorkDayStyle from "../assests/Gold and Brown 3D Gold Anniversary Flyer.png";
import TestImage from "../assests/TestImage.jpg";

const { Title, Paragraph, Text } = Typography;

export default function WorkAnniversary({ employee }) {
    const employeeName = employee?.user?.first_name || 'sample name';
    const organizationName = employee?.organisation_name || 'BCPL';
    const departmentName = employee?.department_name || "ERP";
    const designation = employee?.designation_name || "Designation";

    return (
        <>
            <div
                style={{
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "100vh",
                    background: "transparent",
                }}
            >
                <div
                    style={{
                        position: "relative",
                        width: "400px",
                        height: "600px",
                        background: "white",
                        borderRadius: "10px",
                        boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                        overflow: "hidden",
                    }}
                >
                    {/* Background Template */}
                    <img
                        src={WorkDayStyle}
                        alt="Wedding Anniversary Template"
                        style={{
                            position: "absolute",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            objectFit: "cover",
                            zIndex: 1,
                        }}
                    />

                    <img
                        src={`${employee?.photo}`}
                        alt="Employee"
                        style={{
                            position: "absolute",
                            top: "145px",
                            left: "110px",
                            width: "193px",
                            height: "190px",
                            objectFit: "cover",
                            borderRadius: "8px",
                            zIndex: 2,
                            border: "2px solid white",
                            boxShadow: "0 2px 6px rgba(0,0,0,0.3)",
                        }}
                    />



                    {/* Couple Info */}
                    <div
                        style={{
                            position: "absolute",
                            top: "340px",
                            left: 0,
                            right: 0,
                            textAlign: "center",
                            zIndex: 3,
                            padding: "0 20px",
                            color: "#2e2e2e",
                        }}
                    >
                        <Text
                            style={{
                                display: "block",
                                fontSize: "18px",
                                fontWeight: "500",
                                color: "#4a4a4a",
                                marginBottom: "2px",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {employeeName}
                        </Text>
                        <Text
                            style={{
                                display: "block",
                                fontSize: "15px",
                                fontWeight: "500",
                                color: "#4a4a4a",
                                marginBottom: "2px",
                                textAlign: "center",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {designation} - {departmentName}
                        </Text>

                        <Text
                            strong
                            style={{
                                display: "block",
                                fontSize: "15px",
                                color: "#000000ff",
                                whiteSpace: "nowrap",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                            }}
                        >
                            {organizationName}
                        </Text>
                    </div>

                    {/* Anniversary Wish */}
                    <div
                        style={{
                            position: "absolute",
                            bottom: "95px",
                            left: "0",
                            right: "0",
                            textAlign: "center",
                            padding: "0 40px",
                            zIndex: 3,
                            color: "#5a3e36",
                        }}
                    >
                        <Paragraph
                            style={{
                                fontSize: "13px",
                                color: "#000000ff",
                                fontFamily: "Georgia, serif",
                                lineHeight: "1.5",
                            }}
                        >
                            Wishing you a Wonderfull Journey With Us.
                            <br />
                            <b>
                                Warm wishes from the entire <br />
                                <span style={{ color: "#000000ff" }}>
                                    Baashyaam Group Family!
                                </span>
                            </b>
                        </Paragraph>
                    </div>
                </div>
            </div>
        </>
    );
}
